import { INDUSTRY_UNDEFINED_ID } from 'src/data/industry';
import type { Entity, ID } from 'src/lib/collection';

export interface ScoringMethodInput extends Entity {
  type: ScoringMethodType;
}

export interface ScoringMethod extends Entity {
  type: ScoringMethodType;
  name?: string;
}

export const SCORING_METHOD_TYPE = {
  contentTaxonomy: 'ContentTaxonomy',
  customModel: 'CustomModel',
  autoClassifierScoringModel: 'AutoClassifierScoringModel',
} as const;
export type ScoringMethodType = (typeof SCORING_METHOD_TYPE)[keyof typeof SCORING_METHOD_TYPE];

export const createScoringMethod = ({ id, type, name }: ScoringMethod): ScoringMethod => ({
  id,
  type,
  name,
});

export const createTaxonomyScoringMethod = (id: ID): ScoringMethod =>
  createScoringMethod({ id, type: SCORING_METHOD_TYPE.contentTaxonomy });

export const serializeScoringMethod = (method?: ScoringMethod): string => {
  if (!method) {
    return '';
  }
  return `${method.type}_${method.id}`;
};

export const DEFAULT_SCORING_METHOD = createTaxonomyScoringMethod(INDUSTRY_UNDEFINED_ID);

export const mapScoringMethodForMutation = (scoringMethod: ScoringMethod) =>
  scoringMethod
    ? {
        id: scoringMethod.id,
        type: scoringMethod.type,
      }
    : undefined;

export const isSameScoringMethod = (method1?: ScoringMethod, method2?: ScoringMethod): boolean =>
  serializeScoringMethod(method1) === serializeScoringMethod(method2);
